import React, { useState, useRef, useEffect } from "react";
import useAuth from "../hooks/useAuth";
import Header from "../components/checkout/Header";
import OrderSummary from "../components/checkout/OrderSummary";
import CouponCode from "../components/checkout/CouponCode";
import Address from "../components/checkout/Address";
import PaymentMethods from "../components/checkout/PaymentMethods";
import UserProfile from "../components/checkout/UserProfile";
import BottomSheet from "../components/utils/BottomSheet";
import AddressDetailContainer from "../components/checkout/AddressDetailContainer";
import OrderSummaryContainer from "../components/checkout/OrderSummaryContainer";
import AccountLogin from "../components/utils/AccountLogin";
import Call from "../assets/svg/Call";
import AddAddressForm from "../components/checkout/AddAddressForm";
import BootstrapLoader from "../components/utils/BootstrapLoader";
import useCart from "../hooks/useCart";
import useCoupon from "../hooks/useCoupon";
import useGraffiti from "../hooks/useGraffiti";
import Graffiti from "../components/utils/Graffiti";
import axiosPrivate from "../axios/axiosPrivate";

const Checkout = () => {
  const sheetContainerRef = useRef(null);
  const { token, user, logout, authLoading } = useAuth();
  const { cartData, setCartData } = useCart();
  const { couponData } = useCoupon();
  const { visible } = useGraffiti();
  const [sheetOpen, setSheetOpen] = useState(false);
  const [sheetType, setSheetType] = useState(null);

  const [confirmExitOpen, setConfirmExitOpen] = useState(false);

  const hasPushedRef = useRef(false);

  const openSheet = (type) => {
    setSheetType(type);
    setSheetOpen(true);
  };

  // const cartDataStatic = {
  //   attributes: {},
  //   cart_level_discount_applications: [],
  //   checkout_charge_amount: 474900,
  //   currency: "INR",
  //   item_count: 3,

  //   items: [
  //     {
  //       discounted_price: 145000,
  //       discounts: [],
  //       featured_image: {
  //         aspect_ratio: 0.667,
  //         alt: "Twin zip wide leg cargo pants",
  //         height: 2304,
  //         url: "//hayd.in/cdn/shop/files/4-1719760569044.jpg?v=1730728686",
  //         width: 1536,
  //       },
  //       final_line_price: 145000,
  //       final_price: 145000,
  //       gift_card: false,
  //       grams: 0,
  //       handle: "twin-zip-wide-leg-cargo-pants-black-10045",
  //       id: 49795739123991,
  //       image: "//hayd.in/cdn/shop/files/4-1719760569044.jpg?v=1730728686",
  //       key: "49795739123991:b36363af56c4d88f6766b274a345fabe",
  //       line_level_discount_allocations: [],
  //       line_level_total_discount: 0,
  //       line_price: 145000,
  //       options_with_values: [],
  //       original_line_price: 145000,
  //       original_price: 145000,
  //       price: 145000,
  //       product_description:
  //         "High-waisted, double-zip wide leg cargo pants in organic cotton twill with eight pockets.",
  //       product_has_only_default_variant: false,
  //       product_id: 9726703763735,
  //       product_title: "Twin zip wide leg cargo pants",
  //       product_type: "cargo trousers",
  //       properties: { upsell_discount: "true", upsell_price: 699 },
  //       quantity: 1,
  //       requires_shipping: true,
  //       sku: "10045",
  //       taxable: false,
  //       title: "Twin zip wide leg cargo pants - 36",
  //       total_discount: 0,
  //       url: "/products/twin-zip-wide-leg-cargo-pants-black-10045?variant=49795739123991",
  //       variant_id: 49795739123991,
  //       variant_options: ["36"],
  //       variant_title: "36",
  //       vendor: "HAYD",
  //     },

  //     {
  //       discounted_price: 180000,
  //       discounts: [],
  //       featured_image: {
  //         aspect_ratio: 0.667,
  //         alt: "Day2Night Baggy Fit Jeans",
  //         height: 2304,
  //         url: "//hayd.in/cdn/shop/files/DAY-2-NIGHT-BLUE-6.jpg?v=1771355141",
  //         width: 1536,
  //       },
  //       final_line_price: 180000,
  //       final_price: 180000,
  //       gift_card: false,
  //       grams: 0,
  //       handle: "day2night-baggy-fit-jeans-10118",
  //       id: 52285852221719,
  //       image: "//hayd.in/cdn/shop/files/DAY-2-NIGHT-BLUE-6.jpg?v=1771355141",
  //       key: "52285852221719:6f37f3f895b257ac64e07b0a75aed8b1",
  //       line_level_discount_allocations: [],
  //       line_level_total_discount: 0,
  //       line_price: 180000,
  //       options_with_values: [],
  //       original_line_price: 180000,
  //       original_price: 180000,
  //       price: 180000,
  //       product_description: "Day2Night Baggy Fit Jeans with zip-off feature.",
  //       product_has_only_default_variant: false,
  //       product_id: 10193903157527,
  //       product_title: "Day2Night Baggy Fit Jeans",
  //       product_type: "Jeans",
  //       properties: {},
  //       quantity: 1,
  //       requires_shipping: true,
  //       sku: "1011824",
  //       taxable: false,
  //       title: "Day2Night Baggy Fit Jeans - 24",
  //       total_discount: 0,
  //       url: "/products/day2night-baggy-fit-jeans-10118?variant=52285852221719",
  //       variant_id: 52285852221719,
  //       variant_options: ["24"],
  //       variant_title: "24",
  //       vendor: "HAYD",
  //     },

  //     {
  //       discounted_price: 149900,
  //       discounts: [],
  //       featured_image: {
  //         aspect_ratio: 0.667,
  //         alt: "Front Pocket Wide Jeans",
  //         height: 2304,
  //         url: "//hayd.in/cdn/shop/files/front-pocket-green.jpg?v=1765884647",
  //         width: 1536,
  //       },
  //       final_line_price: 149900,
  //       final_price: 149900,
  //       gift_card: false,
  //       grams: 0,
  //       handle: "front-pocket-wide-jeans-10110",
  //       id: 51720774254871,
  //       image: "//hayd.in/cdn/shop/files/front-pocket-green.jpg?v=1765884647",
  //       key: "51720774254871:30208f18b4bfd0d0ccd5b1b57b061bd3",
  //       line_level_discount_allocations: [],
  //       line_level_total_discount: 0,
  //       line_price: 149900,
  //       options_with_values: [],
  //       original_line_price: 149900,
  //       original_price: 149900,
  //       price: 149900,
  //       product_description: "High-rise wide jeans with front patch pockets.",
  //       product_has_only_default_variant: false,
  //       product_id: 10129947722007,
  //       product_title: "Front Pocket Wide Jeans",
  //       product_type: "Jeans",
  //       properties: {},
  //       quantity: 1,
  //       requires_shipping: true,
  //       sku: "10110",
  //       taxable: false,
  //       title: "Front Pocket Wide Jeans - 24",
  //       total_discount: 0,
  //       url: "/products/front-pocket-wide-jeans-10110?variant=51720774254871",
  //       variant_id: 51720774254871,
  //       variant_options: ["24"],
  //       variant_title: "24",
  //       vendor: "HAYD",
  //     },
  //   ],

  //   items_subtotal_price: 474900,
  //   note: "",
  //   original_total_price: 474900,
  //   requires_shipping: true,
  //   total_discount: 0,
  //   total_price: 474900,
  //   total_weight: 0,
  // };

  useEffect(() => {
    console.log("HAYD CHECKOUT INITIATED .....");

    // SENDING A POST MESSAGE TO TELL A WEBSITE THAT THIS IFRAME LOADED
    window.parent.postMessage({ type: "IFRAME_READY" }, "https://hayd.in");

    const handleMessage = async (event) => {
      // IMPORTANT: Verify Shopify origin
      const allowedOrigins = [
        "https://hayd.in",
        "https://checkout.hayd.in",
        "https://api.razorpay.com",
        " http://localhost",
      ];

      if (!allowedOrigins.includes(event.origin)) {
        console.log("Blocked origin:", event.origin);
        return;
      }

      if (event.data?.type === "SHOPIFY_CART") {
        setCartData(event.data.payload);
      }

      if (event.data?.type === "LANDING_URL") {
        try {
          await axiosPrivate.post("/orders/save-utm", {
            landingUrl: event.data.payload,
          });
        } catch (error) {
          console.error("Error saving UTM:", error.message);
        }
      }
    };
    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };

    // LOCALHOST
    // setCartData(cartDataStatic);
    // LOCALHOST
  }, []);

  useEffect(() => {
    // Push ONE fake history entry per visit
    if (!hasPushedRef.current) {
      window.history.pushState({ checkout: true }, "");
      hasPushedRef.current = true;
    }

    const onPopState = () => {
      // If any sheet is open, allow normal back behavior
      if (sheetOpen) return;

      // If confirm already open, actually leave
      if (confirmExitOpen) {
        window.history.go(-1);
        return;
      }

      // Intercept first back → open confirm sheet
      setConfirmExitOpen(true);

      // Re-push state so URL doesn't change
      window.history.pushState({ checkout: true }, "");
    };

    window.addEventListener("popstate", onPopState);

    return () => {
      window.removeEventListener("popstate", onPopState);
    };
  }, [sheetOpen, confirmExitOpen]);

  if (
    authLoading ||
    !cartData ||
    !Array.isArray(cartData?.items) ||
    cartData?.items?.length === 0
  )
    return (
      <div className="hayd-checkout-outer">
        <div className="hayd-checkout-inner w-[100vw] h-[100dvh] overflow-hidden flex justify-center items-center bg-black bg-opacity-50">
          <div className="hayd-checkout-main relative max-w-[500px] w-[100%] h-[100%] bg-white rounded-xl overflow-hidden">
            <BootstrapLoader />
          </div>
        </div>
      </div>
    );

  return (
    <div className="hayd-checkout-outer">
      <div className="hayd-checkout-inner w-[100vw] h-[100dvh] overflow-hidden flex justify-center items-center bg-black bg-opacity-50">
        <div
          ref={sheetContainerRef}
          className="hayd-checkout-main relative max-w-[500px] w-[100%] h-[100%] bg-slate-100 overflow-hidden"
        >
          <header>
            <Header onBackClick={() => setConfirmExitOpen(true)} />
          </header>
          <div className="hayd-checkout-body p-4 h-[100%] overflow-auto">
            <div className="hayd-checkout-order-summary-container">
              <OrderSummary onClick={() => openSheet("orderSummary")} />
            </div>

            <div className="hayd-checkout-coupon-code-container mt-3 relative overflow-hidden">
              <CouponCode container={sheetContainerRef.current} />
            </div>

            {/* {(!token || !user) && ( */}
            {!user && (
              <div className="hayd-checkout-account-login-container mt-6">
                <AccountLogin />
              </div>
            )}

            {/* {token && user && ( */}
            {user && (
              <>
                {user?.addresses?.length ? (
                  <div className="hayd-checkout-address-container mt-3">
                    <Address onClick={() => openSheet("address")} />
                  </div>
                ) : (
                  <div className="hayd-checkout-address-container mt-3">
                    <AddAddressForm />
                  </div>
                )}

                {user?.addresses?.length ? (
                  <div className="hayd-checkout-payment-method mt-3">
                    <PaymentMethods container={sheetContainerRef.current} />
                  </div>
                ) : null}

                <div className="hayd-checkout-user-profile-container mt-3 pb-28">
                  <UserProfile onClick={() => openSheet("account")} />
                </div>
              </>
            )}
          </div>

          {visible && <Graffiti />}

          {sheetContainerRef.current && (
            <BottomSheet
              open={sheetOpen}
              onOpenChange={setSheetOpen}
              container={sheetContainerRef.current}
              title={
                sheetType === "address"
                  ? "Saved addresses"
                  : sheetType === "orderSummary"
                  ? "Order summary"
                  : "Account"
              }
            >
              {/* ORDER SUMMARY */}
              {sheetType === "orderSummary" && <OrderSummaryContainer />}

              {/* ADDRESS */}
              {sheetType === "address" && (
                <AddressDetailContainer onClose={() => setSheetOpen(false)} />
              )}

              {sheetType === "account" && (
                <div className="p-4">
                  <div className="bg-[#FFFFFF80] p-4 rounded-lg shadow-sm border-[#00000010] border ">
                    <div className="flex items-center gap-3">
                      <div className="border-2 p-1 rounded-full">
                        <Call width={14} height={14} />
                      </div>
                      <p className="text-[14px] general-sans-medium">
                        Logged in as{" "}
                        {user?.first_name === "HAYD_USER"
                          ? "User"
                          : user?.first_name + " " + user?.last_name}
                      </p>
                    </div>
                    <div className="p-4 rounded-lg shadow-sm border border-[#00000010] mt-3 bg-gray-100">
                      {user?.phone && (
                        <p className="text-[16px] general-sans-medium mb-2">
                          +91 {user?.phone?.slice(3)}
                        </p>
                      )}

                      <button
                        className=" text-gray-500 text-[14px] underline"
                        onClick={() => {
                          setSheetOpen(false);
                          logout();
                        }}
                      >
                        Logout
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </BottomSheet>
          )}

          {sheetContainerRef.current && (
            <BottomSheet
              open={confirmExitOpen}
              onOpenChange={setConfirmExitOpen}
              container={sheetContainerRef.current}
              title="Are you sure you want to exit?"
            >
              <div>
                <div className="px-4 py-2 coupon-applied-bg flex justify-center items-center gap-1">
                  <p className="text-[#238017] text-[12px] general-sans-medium">
                    You might miss out on savings of
                  </p>
                  <p className="text-[#238017] text-[14px] supreme-bold">
                    ₹100
                  </p>
                </div>
                <div className="p-4 space-y-3">
                  <button
                    className="peer w-full p-4 rounded-md text-[14px] supreme-medium 
               border border-blue-500 text-black 
               hover:bg-blue-500 hover:text-white 
               transition-colors duration-200"
                    onClick={() => {
                      setConfirmExitOpen(false);
                      window.parent.postMessage(
                        {
                          type: "CLOSE_CHECKOUT_IFRAME",
                        },
                        "*"
                      );
                    }}
                  >
                    Yes, exit checkout
                  </button>

                  <button
                    className="w-full p-4 rounded-md text-[14px] supreme-medium 
               bg-blue-500 text-white border border-blue-500
               peer-hover:bg-transparent 
               peer-hover:text-black 
               peer-hover:border-blue-500
               transition-colors duration-200"
                    onClick={() => setConfirmExitOpen(false)}
                  >
                    No, continue checkout
                  </button>
                </div>
              </div>
            </BottomSheet>
          )}
        </div>
      </div>
    </div>
  );
};

export default Checkout;
